import { isMonday, previousMonday } from 'date-fns'

export const BOOKING_CALENDAR_DAYS = 14

export function getBookingCalendarDates(): Date[] {
  const today = new Date()
  let startOfWeek = today
  if (!isMonday(today)) {
    startOfWeek = previousMonday(today)
  }

  const daysInMonth = new Date(today.getFullYear(), today.getMonth() + 1, 0).getDate()
  const daysToShow = Math.min(daysInMonth, BOOKING_CALENDAR_DAYS)
  const result: Date[] = []

  for (let i = 0; i < daysToShow; i++) {
    result[i] = new Date(startOfWeek.getFullYear(), startOfWeek.getMonth(), startOfWeek.getDate() + i)
  }

  return result
}
